import { render, staticRenderFns } from "./ConfigAlertCommand.vue?vue&type=template&id=435f2463&"
import script from "./ConfigAlertCommand.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports